export default "__VITE_ASSET__DE59CXAa__"